module.exports = __webpack_public_path__ + "static/media/mana.c766a3aa.png";